<template>
  <div class="base-button-expand">
    <img :style="{transform: `rotate(${state === 'close' ? 45 : 0}deg)`}" src="@/assets/img/plus.svg">
  </div>
</template>

<script>
export default {
  props: {
    state: {
      type: String,
      default: 'open'
    }
  }
}
</script>

<style lang="scss" scoped>
.base-button-expand {
  position: relative;
  width: 3rem;
  height: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  background-color: rgba(255, 255, 255, 0.1);
  cursor: pointer;
}
img {
  display: block;
  height: 45%;
}
</style>
